import { useEffect, useState } from "react";

export const useStripeCreditCardForm = () => {
  const [formCompleted, setFormCompleted] = useState(false);
  const [name, setName] = useState("");
  const [nameCompleted, setNameCompleted] = useState(false);
  const [creditCardNumberCompleted, setCreditCardNumberCompleted] =
    useState(false);

  useEffect(() => {
    if (!!nameCompleted && !!creditCardNumberCompleted) setFormCompleted(true);
    else setFormCompleted(false);
  }, [nameCompleted, creditCardNumberCompleted]);

  const onTextInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setName(e.target.value);
    setNameCompleted(e.target.value != "");
  };

  return {
    formCompleted,
    setFormCompleted,
    name,
    setName,
    nameCompleted,
    setNameCompleted,
    creditCardNumberCompleted,
    setCreditCardNumberCompleted,
    onTextInputChange,
  };
};
